import OrbitMap from "@/components/OrbitMap";

const STATUT_COLOR = { performants: "#10B981", surveiller: "#F59E0B", difficulte: "#EF4444", sans_visite: "#94A3B8" };

export default function RegionMapLeaflet({ corners = [], height = 320 }) {
  const points = corners.map((c) => ({
    id: c.id || c.corner, lat: c.lat, lng: c.lng, color: STATUT_COLOR[c.statut] || "#94A3B8", radius: 7,
    popup: (
      <div className="text-[11px] leading-tight">
        <div className="font-bold text-slate-800">{c.corner}</div>
        <div className="text-slate-500">{c.enseigne} · {c.region || "—"}</div>
        {c.score !== undefined && <div className="mt-1">Wasascore : <b>{c.score ?? "—"}</b></div>}
        {c.days_since_visit != null && <div>Dernière visite : il y a {c.days_since_visit}j</div>}
      </div>
    ),
  }));
  return <OrbitMap points={points} height={height} testid="ops-region-map" />;
}
